module.exports = __webpack_public_path__ + "img/optima.727251c9.svg";